ObjectUtils.define('EventType', {

  PAGE_DID_LOAD: 'page_did_load',
  PAGE_DID_RESIZE: 'page_did_resize',
  KEYPRESS_ESCAPE: 'keypress_escape',
  CLICK: 'click',
  SIDEBAR_DID_CHANGE_POSITION: 'sidebar_did_change_position',
  DATA_DID_INVALIDATE: 'data-invalidate',

});
